import React from 'react'
import { ReactComponent as RedDiamond } from '../../../../lib/assets/red_diamond.svg'
import { ReactComponent as RedDiamondNoBorder } from '../../../../lib/assets/red_diamond_noborder.svg'
import { ReactComponent as BlueDiamondNoBorder } from '../../../../lib/assets/blue_diamond_noborder.svg'
import { ReactComponent as BlueDiamond } from '../../../../lib/assets/blue_diamond.svg'

interface Diamond_props {
  rollUnder: boolean
  focus: boolean
}
export default function DiamondSVG({ rollUnder, focus }: Diamond_props) {
  return (
    <>
      {rollUnder ? (
        focus ? (
          <BlueDiamond />
        ) : (
          <BlueDiamondNoBorder />
        )
      ) : focus ? (
        <RedDiamond />
      ) : (
        <RedDiamondNoBorder />
      )}
    </>
  )
}
